<!-- @format -->
<script>
</script>


<main>
  <div class="container">
    <h1 id="terms-and-conditions-terms-">Terms and Conditions (“Terms”)</h1>
    <p>
      <!-- Please read these Terms and Conditions (“Terms”, “Terms and Conditions”)
      carefully before using the <a href="https://shortcase.link">https://shortcase.link</a> 
      website and the mobile application (the “Service”) operated by SHORTCASE (“us”,
      “we”, or “our”). -->
      Please read these Terms and Conditions (“Terms”, “Terms and Conditions”) 
      carefully before using the <a href="https://shortcase.link">https://shortcase.link</a> and 
      <a href="https://shortcase-app.com">https://shortcase-app.com</a>
      websites and the mobile application (the “Service”) operated by SHORTCASE (“us”,
      “we”, or “our”).
      <br>
      <br>
      Your access to and use of the Service is conditioned on your acceptance of
      and compliance with these Terms. These Terms apply to all visitors, users
      and others who access or use the Service.
      <br>
      <br>
      <strong>By accessing or using the Service you agree to be bound by these Terms.
        If you disagree with any part of the terms then you may not access the
        Service.</strong>
        <br>
        <br>
        
      <strong>Chapter 1 General Provisions</strong>
      <br>
      <br>
      <strong>Article 1 (Purpose)</strong>
      <br>
      <br>
      The purpose of this terms and conditions of use (hereinafter referred to
      as this “Terms and Conditions”) is to prescribe the conditions,
      procedures, and requirements for the use of service (hereinafter referred
      to as “Service”).
      <br>
      <br>
      <strong>Article 2 (Notices and Effectiveness of this Terms and Conditions)</strong>
      <br>
      <br>
      We notify the user of the contents of this Terms and Conditions by the
      application screen or homepage (hereinafter referred to as “application
      screen, etc.”)
      <br>
      <br>
      Agreement of this Terms and Conditions means that you agree to visit the
      Service regularly to check any changes made to this Terms and Conditions.
      We are not responsible for any damage caused by users who do not know the
      changed Terms and Conditions.
      <br>
      <br>
      We revise this Terms and Conditions, We clearly notifies the existing
      Terms of Conditions, revised Terms of Conditions, application date of the
      revised Terms and Conditions and the reason for revision for a
      considerable period from 7 days before the application date by the method
      referred to in Paragraph 1. And when the revised contents are important to
      the user, We clearly notifies them for a considerable period from 30 days
      before the application date by the method referred to in Paragraph 1.
      <br>
      <br>
      If the user does not agree to the application of revised Terms and
      Conditions, the user may terminate the Service contract.
      <br>
      <br><strong>Chapter 2 Service Contract</strong>
      <br>
      <br><strong>Article 3 (Establishment of Service Contract)</strong>
      <br>
      <br>
      The Service contract is concluded when the user agrees to this Terms and
      Conditions and applies for Service use after completing the entered
      matter.
      <br>
      <br>
      <strong>Article 4 (Entered matter when applying for Service use)</strong>
      <br>
      <br>
      ① The e-mail or account of the user, which contains other users’ e-mail
      without permission may be deleted or taken legal action under the relevant
      Acts.
      <br>
      <br>
      <strong>Article 5 (Acceptance of application for Service use)</strong>
    <br>
      <br>
      ① If the user enters the information referred to in Paragraph 1 of
      Articles 5 and agrees to the Terms and Conditions and Privacy Policy, We
      automatically approve the Service use.
    <br>
      <br>
      ② We may refuse to accept the application in the following subparagraphs:
    <br>
      <br>a) When the user complies with Paragraph 1 of Article 5<br>
      <br>
      b) When there is a false, missing, or miswriting intentionally or
      accidentally in entered matter in Paragraph 1 of Article 5.
    <br>
      <br>
      c) When user does not agree with this Terms and Conditions and the Privacy
      Policy
    <br>
      <br>d) When action is required in accordance with other relevant Acts<br>
      <br><strong>Article 6 (Privacy Policy)</strong><br>
      <br>
      ① We try to protect users’ personal information under the relevant Acts.
    <br>
      <br>
      ② Regarding the user’s personal information protection, We follow the
      relevant Acts and the Privacy Policy prescribed by us. However, We are not
      responsible for any information disclosed due to the user’s imputation
      except in the case of intention or our gross negligence.
    <br>
      <br><strong>Chapter 3 Obligations and Responsibilities</strong><br>
      <br><strong>Article 7 (User Obligations)</strong><br>
      <br>
      ① Unless there is Our explicit agreement, the user’s right to use is
      limited to the individual, and cannot be transferred, donated or provided
      as collateral.
    <br>
      <br>
      ② The user cannot perform any of the following subparagraphs’ acts when
      using the Service.
    <br>
      <br>
      a) An act of entering false information or using the others’ personal
      information when applying for Service use or changing information
    <br>
      <br>b) An act of violating third party rights, or copyrights, etc.<br>
      <br>
      c) Business activities, such as selling goods or services by using the
      Service
    <br>
      <br>
      d) An act of illegally distributing software or hacking or advertising or
      promoting pornographic sites
    <br>
      <br>
      e) Copying, distributing, or disclosing a portion of the service through automation or non-automated "Scraping," without limitation to this, from any media.
    <br>
      <br>f) An act of interrupting the official provision of Service by our or a
      third party;<br>
      <br>
      g) An act objectively judged to be related a crime.
    <br>
      <br>h) An act of violating other regulations or conditions of use, prescribed
      by us, including this Terms and Conditions<br>
      <br>i) An act of violating other relevant Acts
      <br>
      <br>
      ③ You agree not to post the following user content:<br>
      <br>
      a) Content that is pornographic, fraudulent, immoral, invasive, illegal, harassing, aggressive, or damaging to reputation.<br>
      <br>
      b) Content that may cause harm, loss, physical or mental injury, emotional distress, death, disability, damage, or risk of physical or mental illness to you, others, or animals.<br>
      <br>
      c) Content that may cause other loss or damage to personal or property.<br>
      <br>
      d) Content that exposes children to inappropriate material, requests personal identification information, or attempts to harm or exploit children through any means.<br>
      <br>
      e) Content constituting or contributing to crimes or illegal activities.<br>
      <br>
      f) Content containing illegal, harmful, abusive, racial or ethnic insults, defamation, invasion, harassment, public or other humiliation of others, injury, threat, or content deemed offensive.<br>
      <br>
      g) Content containing illegal information.<br>
      <br>
      h) Content containing information that violates the privacy or publicity rights of third parties.<br>
      <br>
      i) Content promoting racial discrimination, prejudice, hatred, or any form of physical harm against a specific group or individual.<br>
      <br>

      <strong>Article 8 (User Responsibilities)</strong>
      <br>
      <br>
      ① You are solely responsible for your user content and any damages arising from it. This applies whether the user content is in the form of text, graphics, sound, or any other media format. By providing user content through the service, you represent and warrant the following:
      <br>
      <br>
      a) Downloading, copying, and using user content will not infringe on third-party copyrights, patents, trademarks, or trade secret rights, including but not limited to exclusive rights.<br>
      <br>
      b) You have fully complied with third-party licenses related to user content and have performed all necessary actions to successfully convey essential conditions to end-users.<br>
      <br>
      c) User content does not contain viruses or other harmful or destructive content or installations.<br>
      <br>
      d) User content is not spam, machine-generated, designed to induce traffic to third-party sites, enhance search engine rankings for third-party sites, or engage in additional unlawful activities, nor does it contain unethical or unwanted commercial content (such as phishing) designed to deceive recipients about the origin of the material (spoofing, etc.).<br>
      <br>
      e) Content is not obscene, defamatory, damaging to reputation, hateful, or racially or ethnically offensive, and it does not violate third-party privacy or publicity rights.<br>
      <br>

      <strong>Chapter 4 Use of Service</strong><br>
      <br>
      <strong>Article 9 (User content)</strong>
      <br>
      <br>
      ① In certain areas of the service, users may post content externally, such as profile information, screenshots, comments, images, files, and other assets, outside of assets intended for sale.<br>
      <br>
      ② Materials submitted, posted, displayed, or otherwise provided by users to the service are considered "User Content." User Content may include logos, trademarks, service marks, trade names, and other information posted by users, but not limited to these, and is subject to the User Content License Grant below, allowing us to use it for marketing and promotional purposes.<br>
      <br>
      ③ The responsibility for interactions with other users rests entirely with you. While we have the right to monitor disputes between you and other users, we are under no obligation to do so. We are not responsible for your interactions with other users or for the actions or inactions of users.<br>
      <br>

      <strong>Article 10 (Fees and Paid Services)</strong>
      <br>
      <br>

      <strong>1. Billing Policies</strong><br>
      <br>
      ① The price of a specific account, including paid subscription accounts (collectively referred to as "paid subscription accounts"), will be provided at the time of purchase. Unless otherwise specified at the time of purchase or agreed upon by us, fees for paid accounts will be charged in advance for each subscription period ("subscription period") as indicated in the paid account description and are non-refundable.<br>
      <br>
      ② Payment of fees for a paid account entitles you to access the services during the subscription period.<br>
      <br>
      ③ We reserve the right to change the billing fees at any time by posting the changes on the service or notifying you in writing at least 30 days in advance through email. You are responsible for paying the modified billing rates.<br>
      <br>
      ④ Upon expiration of the subscription period, your paid account subscription will automatically renew for additional subscription periods until explicitly canceled by you.<br>
      <br>
      ⑤ When purchasing paid services, including paid accounts, you agree that third-party payment processors such as Paddle, Paypal, may store your credit card or other payment information.<br>
      <br>
      ⑥ You agree to the following regarding the payment of fees for your paid account:<br>
      <br>
      a) Fees charged according to the subscription period of the subscribed services,<br>
      <br>
      b) Fees for other purchasable services,<br>
      <br>
      c) Fees for service usage exceeding the usage limits and other fees imposed on your service usage.<br>
      <br>
      ⑦ We reserve the right to cancel the subscription without prior notice if payment is not processed through the provided payment method.<br>
      <br>
      ⑧ The responsibility for all taxes and fees related to the purchase or sale of services or products under these terms, including sales tax, rests entirely with you. It is your responsibility to determine whether sales tax applies to transactions when purchasing or selling services or products such as assets under these terms, and to collect, report, and remit the correct amount to the relevant authorities.<br>
      <br>
      ⑨ In the event your account or these terms are temporarily suspended or terminated for any reason, you understand and agree that you will not be eligible for a refund, credit, or subscription fee exchange for unused periods.<br>
      <br>

      <strong>2. Account Cancellation</strong>
      <br>
      <br>
      ① You can cancel or delete your account at any time. However, refunds will not be provided in such cases.<br>
      <br>
      ② Refunds or download credits will not be provided for periods during the service usage term when the service was available, but not utilized.<br>
      <br>

      <strong>3. Refund Policy</strong><br>
      <br>
      ① You may request resolution through the issue resolution process if you claim not to have received the assets you ordered or if the received assets differ from the description. While we may play an active role in resolving transaction issues, you understand that we are not obligated to do so.<br>
      <br>
      ② You agree to allow us, at our sole discretion, to make the final decision on all disputes. We reserve the right to correct processing errors discovered. In the event of a processing error, we will rectify it by debiting or crediting your payment method accordingly.<br>
      <br>
      ③ The amount corresponding to the refund period determined by our decision will be refunded through the payment cancellation method.<br>
      <br>
      ④ The refund period is calculated from the payment date to the next payment date, excluding the usage period.<br>
      <br>

      <strong>4. Credit</strong><br>
      <br>
      ① Download credits equivalent to the subscription amount may be added to your account for your convenience at our discretion.<br>
      <br>
      ② Unused download credits expire at the end of each specified subscription period.<br>
      <br>
      ③ Credits cannot be transferred to third parties as gifts or consideration.<br>
      <br>



      <strong>Article 11 (Service time)</strong>
      <br>
      <br>
      ① In principle, the Service is open 24/7. However, the Service may be
      suspended for a period set by our due to system inspection, extension, and
      replacement failures. In this case, We will notify the Service in advance
      or after the interruption.
    <br>
      <br>
      ② We may temporarily or permanently suspend the Service in the following
      cases without prior notice or notice.
    <br>
      <br>
      a) In case of emergency system inspection, extension, replacement, failure
      or malfunction
    <br>
      <br>
      b) In case of compelling reasons, such as a national emergency, power
      outage, or natural disasters
    <br>
      <br>
      c) In case of using the Service is hindered by the excessive using of the
      Service
    <br>
      <br>
      ③ In case of Service interruption under the preceding paragraph, We notify
      the user of the notice in advance. However, it is not the case that
      advance notice is not possible for Service interruption that We cannot
      control.
    <br>
      <br><strong>Chapter 5 Compensation for damages and other matters</strong><br>
      <br><strong>Article 12 (damage compensation, etc.)</strong><br>
      <br>
      ① We do not enter into any agreements or warranties on any particulars not
      specified in this Terms and Conditions with respect to the Service within
      the statutory limits. In addition, We do not guarantee the reliability,
      accuracy, etc. of information, data, facts, or illegality posted on the
      Service by the founder or the user, and We do not take any responsibility.
    <br>
      <br>
      ② In the event that a damage occurs to our due to an illegal act committed
      by the user while using the Service and the violation of the provisions of
      this Terms and Conditions, or that We receive a claim for damages or
      various objections from a third party, the user shall compensate for the
      damage incurred to us.
    <br>
      <br>Last updated: (Feb 2, 2024)
      <br>
      <br>
      <br>
      <br>
    </p>
  </div>
</main>

<style>
  
  .container {
    padding-top: 2em;
    padding-left: 2em;
    padding-right: 2em;
    padding-bottom: 4em;
    height: 100vh;
    /* background-color: white; */
  }

  h1 {
    /* color: #4b494e; */
    color: white;
  }

  p {
    /* color: #4b494e; */
    color: white;
    /* line-height: 0.5em; */
    /* margin-bottom: 1px; */
  }

  li {
    /* color: #4b494e; */
    color: white;
  }

  h1, h2, h3, h4, h5, h6, p, a {
    font-family: 'Lato', sans-serif;
    /* color: black; */
    color: white;
  }
</style>


<!-- <main>
  <div class="container">
    <h1 id="terms-and-conditions-terms-">Terms and Conditions (“Terms”)</h1>
    <p>
      Please read these Terms and Conditions (“Terms”, “Terms and Conditions”)
      carefully before using the <a href="https://shortcase-app.com"
        >https://shortcase-app.com</a
      > website and the mobile application (the “Service”) operated by SHORTCASE (“us”,
      “we”, or “our”).
    </p>
    <p>
      Your access to and use of the Service is conditioned on your acceptance of
      and compliance with these Terms. These Terms apply to all visitors, users
      and others who access or use the Service.
    </p>
    <p>
      <strong
        >By accessing or using the Service you agree to be bound by these Terms.
        If you disagree with any part of the terms then you may not access the
        Service.</strong
      >
    </p>
    <p><strong>Chapter 1 General Provisions</strong></p>
    <p><strong>Article 1 (Purpose)</strong></p>
    <p>
      The purpose of this terms and conditions of use (hereinafter referred to
      as this “Terms and Conditions”) is to prescribe the conditions,
      procedures, and requirements for the use of service (hereinafter referred
      to as “Service”).
    </p>
    <p>
      <strong
        >Article 2 (Notices and Effectiveness of this Terms and Conditions)</strong
      >
    </p>
    <p>
      We notify the user of the contents of this Terms and Conditions by the
      application screen or homepage (hereinafter referred to as “application
      screen, etc.”)
    </p>
    <p>
      Agreement of this Terms and Conditions means that you agree to visit the
      Service regularly to check any changes made to this Terms and Conditions.
      We are not responsible for any damage caused by users who do not know the
      changed Terms and Conditions.
    </p>
    <p>
      We revise this Terms and Conditions, We clearly notifies the existing
      Terms of Conditions, revised Terms of Conditions, application date of the
      revised Terms and Conditions and the reason for revision for a
      considerable period from 7 days before the application date by the method
      referred to in Paragraph 1. And when the revised contents are important to
      the user, We clearly notifies them for a considerable period from 30 days
      before the application date by the method referred to in Paragraph 1.
    </p>
    <p>
      If the user does not agree to the application of revised Terms and
      Conditions, the user may terminate the Service contract.
    </p>
    <p><strong>Chapter 2 Service Contract</strong></p>
    <p><strong>Article 3 (Establishment of Service Contract)</strong></p>
    <p>
      The Service contract is concluded when the user agrees to this Terms and
      Conditions and applies for Service use after completing the entered
      matter.
    </p>
    <p>
      <strong>Article 4 (Entered matter when applying for Service use)</strong>
    </p>
    <p>
      ① The e-mail or account of the user, which contains other users’ e-mail
      without permission may be deleted or taken legal action under the relevant
      Acts.
    </p>
    <p>
      <strong>Article 5 (Acceptance of application for Service use)</strong>
    </p>
    <p>
      ① If the user enters the information referred to in Paragraph 1 of
      Articles 5 and agrees to the Terms and Conditions and Privacy Policy, We
      automatically approve the Service use.
    </p>
    <p>
      ② We may refuse to accept the application in the following subparagraphs:
    </p>
    <p>a) When the user complies with Paragraph 1 of Article 5</p>
    <p>
      b) When there is a false, missing, or miswriting intentionally or
      accidentally in entered matter in Paragraph 1 of Article 5.
    </p>
    <p>
      c) When user does not agree with this Terms and Conditions and the Privacy
      Policy
    </p>
    <p>d) When action is required in accordance with other relevant Acts</p>
    <p><strong>Article 6 (Privacy Policy)</strong></p>
    <p>
      ① We try to protect users’ personal information under the relevant Acts.
    </p>
    <p>
      ② Regarding the user’s personal information protection, We follow the
      relevant Acts and the Privacy Policy prescribed by us. However, We are not
      responsible for any information disclosed due to the user’s imputation
      except in the case of intention or our gross negligence.
    </p>
    <p><strong>Chapter 3 Obligations and Responsibilities</strong></p>
    <p><strong>Article 7 (User’s Obligations)</strong></p>
    <p>
      ① Unless there is Our explicit agreement, the user’s right to use is
      limited to the individual, and cannot be transferred, donated or provided
      as collateral.
    </p>
    <p>
      ② The user cannot perform any of the following subparagraphs’ acts when
      using the Service.
    </p>
    <p>
      a) An act of entering false information or using the others’ personal
      information when applying for Service use or changing information
    </p>
    <p>b) An act of violating third party rights, or copyrights, etc.</p>
    <p>
      c) Business activities, such as selling goods or services by using the
      Service
    </p>
    <p>
      d) An act of illegally distributing software or hacking or advertising or
      promoting pornographic sites
    </p>
    <p>
      e) An act of interrupting the official provision of Service by our or a
      third party;
    </p>
    <p>f) An act objectively judged to be related a crime.</p>
    <p>
      g) An act of violating other regulations or conditions of use, prescribed
      by us, including this Terms and Conditions
    </p>
    <p>h) An act of violating other relevant Acts</p>
    <p><strong>Chapter 4 Use of Service</strong></p>
    <p><strong>Article 8 (Service time)</strong></p>
    <p>
      ① In principle, the Service is open 24/7. However, the Service may be
      suspended for a period set by our due to system inspection, extension, and
      replacement failures. In this case, We will notify the Service in advance
      or after the interruption.
    </p>
    <p>
      ② We may temporarily or permanently suspend the Service in the following
      cases without prior notice or notice.
    </p>
    <p>
      a) In case of emergency system inspection, extension, replacement, failure
      or malfunction
    </p>
    <p>
      b) In case of compelling reasons, such as a national emergency, power
      outage, or natural disasters
    </p>
    <p>
      c) In case of using the Service is hindered by the excessive using of the
      Service
    </p>
    <p>
      ③ In case of Service interruption under the preceding paragraph, We notify
      the user of the notice in advance. However, it is not the case that
      advance notice is not possible for Service interruption that We cannot
      control.
    </p>
    <p><strong>Chapter 5 Compensation for damages and other matters</strong></p>
    <p><strong>Article 9 (damage compensation, etc.)</strong></p>
    <p>
      ① We do not enter into any agreements or warranties on any particulars not
      specified in this Terms and Conditions with respect to the Service within
      the statutory limits. In addition, We do not guarantee the reliability,
      accuracy, etc. of information, data, facts, or illegality posted on the
      Service by the founder or the user, and We do not take any responsibility.
    </p>
    <p>
      ② In the event that a damage occurs to our due to an illegal act committed
      by the user while using the Service and the violation of the provisions of
      this Terms and Conditions, or that We receive a claim for damages or
      various objections from a third party, the user shall compensate for the
      damage incurred to us.
    </p>
    <p>Last updated: (28.10.2023)</p>
  </div>
</main>

<style>
  .container {
    padding-top: 2em;
    padding-left: 3em;
    padding-right: 3em;
    padding-bottom: 4em;
  }

  h1 {
    color: #4b494e;
  }

  p {
    color: #4b494e;
  }

  li {
    color: #4b494e;
  }
</style> -->
